import classnames from "classnames";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { submitFormHandler } from "../../store/actions/formRoutines/reservation";
import { selector } from "../../store/reducers/currentRide";
import CardLayout from "../../layouts/CardLayout";
import UpcomingRides from "../../components/UpcomingRides";
import Steps from "./Steps";
import styles from "./style.module.css";
import { FormFooterPlaceholder } from "./Steps/FormFooter";

const ReservationForm = React.memo((props) => {
  const [ page, setPage ] = useState(1);

  const lastRideId = useSelector((state) => selector(state)?.lastRideId);
  React.useEffect(() => {
    if (lastRideId) {
      setPage(1);
    }
  }, [ lastRideId ]);

  const nextPage = () => setPage(prevCount => prevCount + 1);
  const previousPage = () => setPage(prevCount => prevCount - 1);
  const getTitle = () => {
    switch (page) {
      case 1:
        return "Where are you going?";
      case 2:
        return "Choose a vehicle";
      case 3:
        return "Payment";
      default:
        return undefined;
    }
  };

  return (
    <CardLayout
      title={getTitle()}
      className={classnames(styles.reservationLayout, props.className)}
      footer={<FormFooterPlaceholder className={styles.reservationLayoutFooter} />}
      backButtonHandler={page !== 1 ? previousPage : undefined}
    >
      <UpcomingRides />
      <Steps page={page} nextPage={nextPage} submitFormHandler={submitFormHandler} />
    </CardLayout>

  );
});

export default ReservationForm;

